import { useSelector } from "react-redux";

import { copy } from "shared/assets";
import { IJSONAPIErrorCodes } from "shared/types";
import { dataMetaSelector } from "Bands/state";
import { useAPIError } from "./useAPIError";

const deleteMemberCopy = copy.members.deleteMember;

export const useLastMemberError = (action: string) => {
  const { api: apiMeta } = useSelector(dataMetaSelector(action));

  const { error } = useAPIError({
    apiError: apiMeta?.error,
    message: deleteMemberCopy.messages.lastMember,
    errorCode: IJSONAPIErrorCodes.LastMemberException,
  });

  return { error };
};
